import {connect} from 'react-redux'
import ListeContracts from "./ListeContracts";
import {getDataContracts} from "../../../../../../redux/selectors/contracts/contracts.selectors";
import {postTerminateAssuranceTransitoire} from "../../../../../../redux/actions/app/contracts/contracts.actions";
import {terminateAssuTransitoireGetLink} from "../../../../../../redux/selectors/links/links.selectors";

const mapStateToProps = state => {
    return {
        contracts: getDataContracts(state),
        query_terminate_assu_transitoire: terminateAssuTransitoireGetLink(state)
    }
}

const mapDispatchToProps = {
    postTerminateAssuranceTransitoire
}

const ListeContractsContainer = connect(mapStateToProps, mapDispatchToProps)(ListeContracts)

export default ListeContractsContainer